import { PaymentType, type Registration } from '@/types/tournament.model';
import { isActiveRegistration } from '@/utils/registration-status';

/**
 * Whether cancelling touches a payment that skipped the gateway: cash handed to the club, or one
 * the manager recorded by hand. Their GetMatch fee is what the current account owes, so these are
 * the payments whose fee either goes back or stays as debt.
 */
export const hasPaymentsWithoutGateway = (
  registrations: Registration[] = [],
): boolean =>
  registrations.some((registration) => {
    // a cancelled registration keeps its payments as they were: cancelling the tournament skips it
    if (!isActiveRegistration(registration.status)) return false;
    const payers =
      registration.paymentMethod === PaymentType.CASH
        ? registration.payedBy
        : registration.managerPayedBy;
    return (payers?.length ?? 0) > 0;
  });
